import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

const TipoClienteSelect = ({ value, onChange, className = "" }) => {
  return (
    <FormControl fullWidth className={className}>
      <InputLabel id="demo-simple-select-label-telefono">
        Tipo de Cliente
      </InputLabel>
      <Select
        size="small"
        labelId="demo-simple-select-label-telefono"
        id="demo-simple-select-telefono"
        value={value}
        label="Tipo de Cliente"
        onChange={(event) => onChange(event.target.value)}
        sx={{ mb: 2 }}
      >
        <MenuItem value={"P"}>Plataforma</MenuItem>
        <MenuItem value={"N"}>No Paga Interes</MenuItem>
        <MenuItem value={"F"}>No Firma Pagare</MenuItem>
      </Select>
    </FormControl>
  );
};

export default TipoClienteSelect;
